<template>
  <pre class="code-snippet" v-html="code"></pre>
</template>

<script>
export default {
  name: 'CodeSnippet',

  data () {
    return {
      code: ''
    }
  },

  mounted () {
    this.code = this.$slots.default[0].text.trim()
  },

  updated () {
    this.code = this.$slots.default[0].text.trim()
  }
}
</script>

<style lang="sass" scoped>
@import '@/styles/variables.sass'

.code-snippet
  padding: $margin
  background: rgba($font-color, 0.05)
  &:not(:only-child)
    max-width: 50%
    min-width: 50%
</style>
